import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { Cart_Fragment } from "#/graphql/shopify-storefront/fragments";

export const CartLinesAdd_Mutation = graphqlShopifyStorefront(
  `
  mutation CartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cartMasked: cart {
        ...Cart
      }
      userErrors {
        field
        message
      }
    }
  }
`,
  // [Cart_Fragment],
);

export const CartBuyerIdentityUpdate_Mutation = graphqlShopifyStorefront(
  `
  mutation CartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {
    cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
      cartMasked: cart {
        ...Cart
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`,
  // [Cart_Fragment],
);

export const CartCreate_Mutation = graphqlShopifyStorefront(
  `
  mutation CartCreate($input: CartInput!) {
    cartCreate(input: $input) {
      cartMasked: cart {
        ...Cart
      }
      userErrors {
        field
        message
      }
    }
  }
`,
  // [Cart_Fragment],
);

export const CartLinesUpdate_Mutation = graphqlShopifyStorefront(
  `
  mutation CartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cartMasked: cart {
        ...Cart
      }
      userErrors {
        field
        message
      }
    }
  }
`,
  // [Cart_Fragment],
);

export const CartLinesRemove_Mutation = graphqlShopifyStorefront(
  `
  mutation CartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cartMasked: cart {
        ...Cart
      }
      userErrors {
        field
        message
      }
    }
  }
`,
  // [Cart_Fragment],
);
